import cases from '../data/cases/caseList.json';

export const getAllCases = () => {
    return cases['data'];
};